module.exports = __webpack_public_path__ + "img/3.10170238.png";